import { render, staticRenderFns } from "./VesselCourseUnknown.vue?vue&type=template&id=4e5b60d0&scoped=true&"
import script from "./VesselCourseUnknown.vue?vue&type=script&lang=js&"
export * from "./VesselCourseUnknown.vue?vue&type=script&lang=js&"
import style0 from "./VesselCourseUnknown.vue?vue&type=style&index=0&id=4e5b60d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b60d0",
  null
  
)

export default component.exports